export enum DoorType {
    NONE = 'NONE',
    SINGLE = 'SINGLE',
    DOUBLE = 'DOUBLE'
}
